import { memo, useEffect, useState } from "react";

import { CircularProgress, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { dateMiladiToShamsi } from "common/method/date";
import { useSelector } from "react-redux";
import Description from "../description";
import { returnOfInvestmentAnalysis } from "../nlg/nlg";
import TreeMapChart from "common/components/TreeMap";
import { seprateNumberFromComma } from "common/method/seprateNumberFromComma";
import { useTheme, useMediaQuery } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
}));

const TreeMapBox = memo(({ tip }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const reducerportfolioDetailLast = useSelector(
    (state) => state.select_last_portfolio_detail_reducer,
  );
  const loadingReducer = useSelector((state) => state.loading);

  const [relatedDate, setRelatedDate] = useState("");

  const reducerportfolioDetail = useSelector(
    (state) => state.select_portfolio_detail_reducer,
  );
  const reducerportfolio = useSelector(
    (state) => state.select_portfolio_reducer,
  );

  const analysis = returnOfInvestmentAnalysis(
    reducerportfolioDetail,
    reducerportfolioDetailLast,
    reducerportfolio,
  );

  useEffect(() => {
    if (reducerportfolioDetailLast?.data.length !== 0) {
      // let a = reducerportfolioDetailLast?.data[0].body.related_date
      let date = dateMiladiToShamsi(
        reducerportfolioDetailLast?.data[0].body.related_date,
      );
      setRelatedDate(date);
    }
  }, [reducerportfolioDetailLast]);
  const _data =
    reducerportfolioDetailLast?.data?.map((item) => item?.body) || [];

  const detailRows = [
    {
      label: "ارزش کل(ریال)",
      key: "total_value",
      formatter: (i) => seprateNumberFromComma(i.total_value),
    },
    {
      label: "میانگین قیمت خرید",
      key: "average_price",
      formatter: (i) => seprateNumberFromComma(i.average_price),
    },
    {
      label: "تعداد",
      key: "quantity",
      formatter: (i) => (i.quantity ? seprateNumberFromComma(i.quantity) : "-"),
    },
    {
      label: "بازدهی",
      key: "symbol_return",
      formatter: (i) => (i.symbol_return * 100).toFixed(2) + " %",
      colorResolver: (i) =>
        i.symbol_return > 0 ? "green" : i.symbol_return < 0 ? "red" : "black",
    },
    {
      label: "گروه",
      key: "group_name",
    },
    {
      label: "نام کامل",
      key: "stock_full_name",
    },
    {
      label: "تاریخ بروزرسانی",
      key: "related_date",
      formatter: (i) => dateMiladiToShamsi(i.related_date),
    },
  ];

  return (
    <div>
      <div
        className="flex justify-between items-center"
        style={{ width: "max-content" }}
      >
        <h1 className="pr-3 mt-2 mx-2">سبد سرمایه گذاری</h1>
        <Tooltip
          className="mt-3"
          title={
            <p className="p-2 m-0">
              {tip}

              {/* <video width="300" height="200" controls autoPlay>
                <source src="/media/video/Systematic Vs Unsystematic Risk 2.mp4" type="video/mp4" />
              </video> */}
            </p>
          }
          placement={isMobile ? "bottom" : "left"}
          arrow
          classes={{ tooltip: classes.tooltip }}
          enterTouchDelay={1}
        >
          <img src="/media/image/Group 12485.png" alt="" />
        </Tooltip>
      </div>
      {relatedDate && (
        <div className="text-gray-600 text-sm mr-5">({relatedDate})</div>
      )}

      <div className="grid grid-cols-4">
        <div className="col-span-12 lg:col-span-4">
          <div className="text-sm text-gray-700 p-5">
            در این قسمت می‌توانید ترکیب پرتفوی سپرده‌گذاری خود را در سه روز کاری
            قبل مشاهده نمایید. این نمودار در انتهای هر روز بروزرسانی می‌شود.
            ترکیب سبد سرمایه فعلی شما توسط تحلیل‌گر خودکار کارگزاری پیشرو تحلیل
            شده است. نتایج این تحلیل در ادامه این بخش ذکر شده است.
          </div>
          <Description analysis={analysis} />
        </div>
        <div style={{ maxWidth: "100%" }} className="col-span-12 lg:col-span-8">
          {loadingReducer.loading ? (
            <div className="h-full w-full flex justify-center items-center">
              <CircularProgress />
            </div>
          ) : (
            <div>
              {reducerportfolioDetailLast?.data?.length !== 0 && (
                <div style={{ overflowX: "auto" }}>
                  {/* <TreeMap
										reducerportfolioDetail={reducerportfolioDetailLast}
									/> */}
                  <TreeMapChart
                    data={_data}
                    nameKey="stock_short_name"
                    sizeKey="quantity"
                    colorResolver={(item) =>
                      item.symbol_return > 0
                        ? "#02AD65"
                        : item.symbol_return < 0
                          ? "#D62D4D"
                          : "#8d8f91"
                    }
                    detailRows={detailRows}
                    height={600}
                    seriesTitle={"کل پرتفوی"}
                    minFontSize={{ desktop: 24, mobile: 12 }}
                    maxFontSize={{ desktop: 64, mobile: 36 }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default TreeMapBox;
